<ng-container *ngIf="amISysAdmin$ | async">
  <nz-collapse>
    <nz-collapse-panel [nzHeader]="title" [nzExtra]="extraTpl">
      <pre>{{data | json}}</pre>
    </nz-collapse-panel>
  </nz-collapse>
  <ng-template #extraTpl>
    <span class="text-black text-15" nz-icon nzType="bug" nzTheme="outline"></span>
  </ng-template>
</ng-container>
